module.exports = __webpack_public_path__ + "media/images/flags/16/Djibouti-2b7c29bfef70521cc014a031b133e27e.png";